export var FieldType;
(function (FieldType) {
    FieldType["INPUT"] = "input";
    FieldType["SELECT"] = "select";
    FieldType["CHECK"] = "check";
    FieldType["CUSTOM"] = "custom";
})(FieldType || (FieldType = {}));
